// extracted by mini-css-extract-plugin
export default {"cardContent":"cardContent__euC5z","cardBody":"cardBody"};